import { Action } from "@ngrx/store";

import { DocumentState } from "./state";

export type Actions =
    | Update
    | SetupSignature
    | SetSignature
    | ClearSignatures
    | Build
    | Finalize;

export class Update implements Action {
    static readonly type = "document/update";
    readonly type = Update.type;

    private constructor(
        public readonly updates: [keyof DocumentState, any][],
    ) {}

    public static create(): Update {
        return new Update([]);
    }

    public set<Key extends keyof DocumentState, T>(
        key: Key,
        value: DocumentState[Key],
    ): Update {
        return new Update([...this.updates, [key, value]]);
    }
}

export class SetupSignature implements Action {
    static readonly type = "document/setup-signature";
    readonly type = SetupSignature.type;

    constructor(
        public index: number,
        public canvas: any,
    ) {}
}

export class SetSignature implements Action {
    static readonly type = "document/set-signature";
    readonly type = SetSignature.type;

    constructor(
        public index: number,
        public dataUrl: string,
    ) {}
}

export class ClearSignatures implements Action {
    static readonly type = "document/clear-signatures";
    readonly type = ClearSignatures.type;
}

export class Build implements Action {
    static readonly type = "document/build";
    readonly type = Build.type;

    constructor(public force = false) {}
}

export class Finalize implements Action {
    static readonly type = "document/finalize";
    readonly type = Finalize.type;
}
